/**
 * Constantes de rutas de la aplicación.
 * Centraliza las definiciones de rutas para evitar duplicación.
 */

/**
 * Rutas públicas que no requieren autenticación.
 * Estas rutas están duplicadas en múltiples archivos, por lo que
 * se centralizan aquí para mantener consistencia.
 */
export const PUBLIC_ROUTES = [
  '/login',
  '/register',
  '/create-first-admin',
  '/privacy-policy',
  '/cookie-policy'
] as const;

/**
 * Endpoints públicos de la API que no requieren autenticación.
 */
export const PUBLIC_API_ENDPOINTS = [
  '/auth/login',
  '/auth/register',
  '/auth/needs-first-admin',
  '/auth/setup-token',
  '/auth/create-first-admin'
] as const;

/**
 * Verifica si una ruta es pública.
 * @param path - Ruta a verificar
 * @returns true si la ruta es pública, false en caso contrario
 */
export const isPublicRoute = (path: string): boolean => {
  return PUBLIC_ROUTES.includes(path as typeof PUBLIC_ROUTES[number]);
};

/**
 * Verifica si un endpoint de API es público.
 * @param endpoint - Endpoint a verificar
 * @returns true si el endpoint es público, false en caso contrario
 */
export const isPublicEndpoint = (endpoint: string): boolean => {
  return PUBLIC_API_ENDPOINTS.some(publicEndpoint => 
    endpoint.includes(publicEndpoint)
  );
};

